import React from "react";
import { WithFieldValue, DocumentData } from "firebase/firestore";
import { Alert, Text } from "@chakra-ui/react";

import { PRODUCTION_STEPS_AUX } from "@constants";
import { useCustomToast } from "@hooks";

import {
  JsonForm,
  JsonFormControl,
  makeCommentsControl,
  makeSelectControl,
} from "../JsonForm";
import { ButtonModal } from "../ModalWrappers";
import { useAddAuxStep } from "./useAddAuxStep";

type AddDetachROHModalProps = {
  itemId: string;
};

function makeDetachROHControl() {
  const tags = ["Yes"];
  return [
    makeSelectControl(
      "Detach?",
      "detach",
      tags,
      "Please confirm that you are detaching ROH.",
    ),
    makeCommentsControl(),
  ] as JsonFormControl[];
}

export function AddDetachROHModal({ itemId }: AddDetachROHModalProps) {
  const tagFormControl = React.useMemo(() => makeDetachROHControl(), []);
  const addTagToast = useCustomToast(() => (
    <Alert status="success">ROH detached!</Alert>
  ));
  const [error, setError] = React.useState("");
  const addStep = useAddAuxStep(
    itemId,
    PRODUCTION_STEPS_AUX.STEP_AUX_DETACH_ROH,
    addTagToast,
    setError,
  );
  const doSubmit = React.useCallback(
    async function <T extends WithFieldValue<DocumentData>>(data: T) {
      const comments = "Detaching ROH";
      (data.comments ? (data.comments as string) + ", " : "") + "detaching ROH";
      addStep(comments);
    },
    [addStep],
  );

  return (
    <ButtonModal label="Detach ROH" title="Detach ROH" size="sm">
      <JsonForm fields={tagFormControl} onSubmit={doSubmit} clearAfterSubmit />
      {error ? <Text>{error}</Text> : undefined}
    </ButtonModal>
  );
}
